import { AsyncSelectInputSingle } from '@frontend/basic-forms';

import useTerminalSelect from './terminal-select.controller';

const ID = 'terminal-select';
export interface TerminalSelectProps {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    submitted: boolean;
    onChange: (newValue?: string) => void;
    value?: { value: string; label: string } | string;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
}

const TerminalSelect = (props: TerminalSelectProps) => {
    const viewProps = useTerminalSelect(props);

    return (
        <AsyncSelectInputSingle
            id={props.id || ID}
            label={props.label || 'Terminal'}
            className={props.className}
            submitted={props.submitted}
            required={props.required}
            options={viewProps.options}
            onChange={(newValue) => props.onChange(newValue?.value)}
            value={viewProps.value?.value}
            isDisabled={props.disabled}
            onMenuScrollToBottom={viewProps.onScrollToBottom}
            loadOptions={viewProps.search}
            isClearable={props.isClearable}
            useConditionedStyling={props.useConditionedStyling}
        />
    );
};

export default TerminalSelect;
